import React, { useState, useEffect, useContext } from 'react';

import * as utils from "../../../../assets/utils";
import * as net from "../../../../lib/net";
import Pms_Rvo from "../../../rv/rvo";
import Dd_Sel from "../../../../lib/ui/dd_sel";
import Td_Sel from "../../../../lib/ui/td_sel";

class Move_Rows extends React.Component {
  constructor(props, context) {
    super(props);

     this.selitems = [
        {fkn: 'setup', text: 'INSTÄLLNINGAR'},
        {fkn: 'upd', text: 'UPPDATERA'},
        {fkn: 'sys', text: 'SYSTEM'},
        {fkn: 'logout', text: 'LOGGA UT'}
    ];

   //this.webStore = props.store;
    this.state = {};
    this.state.ynq = [];
    this.state.rva = [];
    this.state.nta = [];
    this.state.srow = {};
    this.state.styp = "inh";
    this.state.boknr = "";
    this.state.rvo = {};
    this.state.gsb00 = {};

    if(props.wnds) {
        this.fkn_close = props.wnds.fkn_close;
        this.state.boknr = props.wnds.boknr;
        this.state.rvo = props.wnds.rvo;
        this.state.gsb00 = props.wnds.gsb00;
    }
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      this.gst_rows();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }

    wnd_close() {
      var rsp = {};
      rsp.ok = "999";

      if(this.fkn_close) this.fkn_close(this.props.ctx, rsp);
      else this.props.ctx.setState({ wnds: {} });
	};
    collect() {
        var cra = [];
        var gsa = Object.values(this.state.srow);
        for(var row of gsa) {
            for(var tro of row.trs) {
                var o = {};
                o.gsb00 = row.gsb00;
                o.etr01 = tro;
                cra.push( o );
            }
        }
        if(cra.length < 1) {
            alert("Inget att samla in!");
            return;
        }
      var rsp = {};
      rsp.ok = "000";
      rsp.cra = cra;

      if(this.fkn_close) this.fkn_close(this.props.ctx, rsp);
      else this.props.ctx.setState({ wnds: {} });
	};
  tb_style() {
      var css = {};
      css.height = (window.innerHeight * 0.9) - 275;
      css.overflow = "auto";
      return css;
  }
  sel_style(typ) {
    var css = {};
    var styp = this.state.styp;
    if(typ == styp) {
        css.background = "#080";
        css.color = "#fff";
    }
    return css;
  }
  mrow_style(row) {
    var srow = this.state.srow;
    var key = row.gsb00.r0boknr + row.gsb00.r0glopnr;
    var css = {};
    if(srow[key]) {
        css.background = "#080";
        css.color = "#fff";
    }
    return css;
  }
  row_style(row) {
    var srow = this.state.srow;
    var css = {};
    if(srow == row) {
        css.background = "#080";
        css.color = "#fff";
    }
    return css;
  }
  sel_typ(typ) {
    var self = this;
    var styp = this.state.styp;
    self.setState({ styp: typ });
    if(typ == "inh") {
      self.gsts_inh();
    }
    if(typ == "pco") {
      self.gsts_pco();
    }
  }

  gst_rows() {
    var self = this;
    var prm = {};
    prm.req = "pms.charge.charges_xxp";
    prm.boknr = this.state.gsb00.r0boknr;
    prm.glopnr = this.state.gsb00.r0glopnr;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        var tot = ret.tot;
        var nta = ret.rca;
        self.setState({ nta: nta, tot: tot });
        self.syncTb("gsrTable");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
    syncTb(tb){
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
        tdElements = tbel.getElementsByTagName('td');

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
            width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
  sel_mrow(row) {
    var srow = this.state.srow;
    var key = row.gsb00.r0boknr + row.gsb00.r0glopnr;
    if(srow[key]) {
      delete( srow[key] );
    }
    else srow[key] = row;
    this.setState({srow: srow});
  }
  sel_row(row) {
    var srow = this.state.srow;
    if(srow == row) {
      srow = {};
    }
    else srow = row;
    this.setState({srow: srow});
  }

  sel_rows() {
    var self = this;
    var srow = this.state.srow;
    if(srow == {}) {
        return;
    }
    self.move_row(srow);
  }
  move_row(row) {
    var self = this;

    var lopnr = row.etr01.e0lopnr;

    var prm = {};
    prm.req = "pms.split.move_tr_togst";
    prm.boknr = this.state.boknr;
    prm.gso = this.state.rvo.gsb00;
    prm.lopnr = lopnr;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rco));

      if(self.fkn_close) self.fkn_close(self.props.ctx);
      else self.props.ctx.setState({ wnds: {} });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }

  render() {
    //if(!this.props.show) return "";

    var title = this.props.title;
    if(!title) title = "";

	var html =
        <div className="mx_base">
        { this.props.backdrop ? <div className="m2_backdrop" /> : null }
        <div className="m2_dlg mx_70h flex-col" style={ this.dlg_style() }>
        <div className="flex-row " style={{padding:"0px",height:"50px",lineHeight:"50px", background: "#1a456b", color: "#fff"}}>
                <div className="flex-row flex" style={{padding:"0px 5px", fontSize: "22px"}}>
                    <div>VÄLJ RADER { this.state.rumsnr }</div>
                </div>
            <div className="">
                <Dd_Sel items={ this.selitems } cls="web-top-icon" getValue={(e)=> this.sel_fkn(e)} />
            </div>
        </div>
        <div className="mx_content flex">

        <div className="web-row flex">
        <div className="web-col flex" style={{padding: "0px"}}>

        <div id="gsrTable">
          <table className="table table-bordered table-hover" style={{marginBottom: "0px"}}>
            <thead>
            <tr>
                <th>Datum</th>
                <th>T</th>
                <th>Typ</th>
                <th>Text</th>
                <th>Antal</th>
                <th>Pris</th>
                <th>Summa</th>
                <th>Tecken</th>
                <th>Löpnr</th>
                <th></th>
            </tr>
            </thead>
        </table>
        <div style={ this.tb_style() }>
          <table className="table table-bordered table-hover">
            <tbody>
            { this.state.nta.map((row, key) =>
            <tr key={key} style={ this.row_style(row) } onClick={ () => this.sel_row(row) } onDoubleClick={ () => this.move_row(row) }>
                <td>{ row.etr01.e0datum.cdidate() }</td>
                <td>{ row.etr01.e0bastyp }</td>
                <td>{ row.etr01.e0typ }</td>
                <td>{ row.etr01.e0text.toswe() }</td>
                <td className="text-center">{ row.etr01.e0antal.ztrim() }</td>
                <td className="text-right">{ row.etr01.e0pris.cdipris() }</td>
                <td className="text-right">{ ((row.etr01.e0antal * 1) * (row.etr01.e0pris * 1)).cdipris() }</td>
                <td>{ row.etr01.e0tkn }</td>
                <td>{ row.etr01.e0lopnr.ztrim() }</td>
                <td>
                    <Td_Sel items={ this.rowitems } getValue={(e)=> this.sel_row_fkn(row, e)} />
                </td>
            </tr>
            )}
            </tbody>
        </table>
        </div>
        </div>

        </div>
        </div>

        </div>
        <div className="mx_foot flex-row">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex"></div>
            <button className="btn btn-hw-green w250" onClick={(event) => this.sel_rows() } >
                VÄLJ MARKERADE
            </button>
        </div>
      </div>
            { this.state.wnd_rvo ?
        <Pms_Rvo close={this.rvo_close} boknr={this.state.boknr} ctx={this} store={this.props.store} backdrop={true}/>
            : null }
    </div>
	;
	return html;
  };
}

export default Move_Rows;